const DESKTOP_BREAKPOINT = 1023;

export default class BaseCarousel {
  constructor(selector, mobileOnly, showCardCount, jsonOptions) {
    this.carouselList = document.querySelectorAll(selector);
    this.jsonOptions = jsonOptions;
    const isMobile = window.innerWidth < DESKTOP_BREAKPOINT;
    if (
      this.carouselList.length > 0 &&
      ((isMobile && mobileOnly) || !mobileOnly)
    ) {
      this.splideElements = this.getSplideElements();
      this.splides = this.getSplides();
      this.initSplides();
      this.setSplideListeners();

      if (showCardCount) {
        this.setCardCountNumbers();
      }
    }
  }

  setCardCountNumbers() {
    this.carouselList.forEach((carousel, carouselIndex) => {
      const slideCountElement = carousel.querySelector('.slide-count');
      const ofTextField = carousel.querySelector('.of-text');
      const ofText = ofTextField ? ofTextField.textContent : '';
      const currentSplide = this.splides[carouselIndex];
      if (slideCountElement) {
        slideCountElement.textContent = `${currentSplide.index + 1} ${ofText} ${
          currentSplide.length
        }`;
      }
    });
  }

  getSplideElements() {
    const splides = [];
    this.carouselList.forEach(carousel => {
      splides.push(carousel.querySelector('.splide'));
    });
    return splides;
  }

  /* istanbul ignore next */
  setSplideListeners() {
    if (this.carouselList.length > 0) {
      this.splides.forEach(splide => {
        splide.on('moved', () => {
          this.setCardCountNumbers();
        });
      });
    }
  }

  getSplides() {
    const splides = [];
    this.splideElements.forEach(splide => {
      if (splide) {
        splides.push(new Splide(splide, this.jsonOptions));
      }
    });
    return splides;
  }

  initSplides() {
    if (this.carouselList.length > 0) {
      this.splides.forEach(splide => {
        splide.mount();
      });
    }
  }
}
